/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomer} from '../api'

 export const useQueryGetCustomer = createReactQueryHook('getCustomer', getCustomer)
